import script from "./EditMatchScoreFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMatchScoreFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditMatchScoreFormComponent.vue?vue&type=style&index=0&id=c529aaec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c529aaec"]])

export default __exports__